import { render, staticRenderFns } from "./listaUnidades.vue?vue&type=template&id=4b18fc7c&scoped=true"
import script from "./listaUnidades.vue?vue&type=script&lang=js"
export * from "./listaUnidades.vue?vue&type=script&lang=js"
import style0 from "./listaUnidades.vue?vue&type=style&index=0&id=4b18fc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18fc7c",
  null
  
)

export default component.exports